import { RestService } from 'services/restService';
import { ApiError } from 'services/restService';

export interface DeploymentResponse {
	deploymentId: string;
	nextUrl: string;
}

export const startDeployment = (orgId: string, subId: string, groupId: string): Promise<DeploymentResponse> => new Promise((res, rej) => {
	const data = {
		OrganizationId: orgId,
		SubscriptionId: subId,
		ResourceGroupId: groupId
	};

	RestService.post({ endPoint: '/api/Deployment', data})
		.then((response: DeploymentResponse) => {
			res(response);
		})
		.catch((error: ApiError) => {
			rej(error);
		});
});
